import React from 'react';
import { useNavigate } from 'react-router-dom';
import RulesModal from '../RulesModal/RulesModal';
import './GameToolbar.css';

export default function GameToolbar({ rules = [] }) {
  const navigate = useNavigate();

  return (
    <div className="game-toolbar">
      <button type="button" className="game-back-btn" onClick={() => navigate('/hub')}>
        Home
      </button>
      <RulesModal rules={rules} />
    </div>
  );
}
